import { jsx as r, jsxs as f, Fragment as s } from "react/jsx-runtime";
import { Accordion as p } from "../Accordion/index.js";
import l from "./productHazardsTab.module.js";
import { useTranslation as g } from "../../hooks/useTranslation.js";
import { SectionBlock as t } from "../SectionBlock/SectionBlock.js";
const j = ({
  productData: n,
  className: _,
  language: o
}) => {
  var d, m;
  const { t: h } = g(), { hazards_statements: i, precautionary_statements: c } = n || {};
  return (i[0] || c[0]) && /* @__PURE__ */ r("div", { className: _, children: /* @__PURE__ */ r(
    p,
    {
      className: l.accordion,
      header: h("safety_info"),
      headingLevel: "h2",
      children: /* @__PURE__ */ f("div", { className: l.accordionContent, children: [
        ((d = i[0]) == null ? void 0 : d.recommended_hazard_text) && /* @__PURE__ */ r(s, { children: i.filter(
          (e) => e.language === o || !i.some(
            (a) => a.language === o
          ) && e.language === "fi"
        ).map((e) => /* @__PURE__ */ r(t, { children: /* @__PURE__ */ r("p", { children: e.recommended_hazard_text }) }, e.hazard_statement_code)) }),
        ((m = c[0]) == null ? void 0 : m.recommended_precautionary_text) && /* @__PURE__ */ r(s, { children: n == null ? void 0 : n.precautionary_statements.filter(
          (e) => e.language === o || !n.precautionary_statements.some(
            (a) => a.language === o
          ) && e.language === "fi"
        ).map((e) => /* @__PURE__ */ r(t, { children: /* @__PURE__ */ r("p", { children: e == null ? void 0 : e.recommended_precautionary_text }) }, e.precautionary_statement_code)) })
      ] })
    }
  ) });
};
export {
  j as ProductHazardsTab
};
